import React from "react";
import { formatNumberFixed } from "../../utils/helper";

interface ContentCellMoneyProps {
  value?: number | null;
}

const ContentCellMoney: React.FC<ContentCellMoneyProps> = ({ value }) => {
  if (value == null) return <span></span>;
  return <span style={{ textAlign: "right" }}>{formatNumberFixed(value)}</span>;
};

export default ContentCellMoney;
